export default __webpack_public_path__ + "static/media/portfolio-208.477f4fa2.jpg";